import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';



import Card from '../../../../../Base/Components/Card/Card';
import { toastShow } from '../../../../../Base/Services/ToastService';
import { AuthContext } from '../../../../../Base/Context/AuthContext/AuthContext';
import AutoCompleteDropdown from '../../../../../Base/Components/Form/AutoCompleteDropdown';
import { ArchivosExcelService, exportarExcel } from '../../../../../Base/Services/ArchivosService';


import ArchivosRequisicion from './ArchivosRequisicion';


const EncabezadoRequisicion = ({ values, setValues, handleInputChange, guardarEncabezado, agregarNuevaFila, setHabilitar, eliminarItemDetalle, toast, resetForm, habilitar, guardarRequisa = () => { }, table, getRequisa, areas, agentes, agentesCompras}) => {


    const { userAuth } = useContext(AuthContext);

    const [newRequisaDialog, setNewRequisaDialog] = useState(false);
    const [loadingCorreo, setLoadingCorreo] = useState(false);


    const prioridades = [
        { id: 1, prioridad: "Urgente" },
        { id: 2, prioridad: "Alta" },
        { id: 3, prioridad: "Media" },
        { id: 4, prioridad: "Baja" }
    ]

    const tipos = [
        { id: 1, tipo: "Local" },
        { id: 2, tipo: "Online" },
        { id: 3, tipo: "Internacional" },
        { id: 4, tipo: "Proyecto" },
        { id: 5, tipo: "Caja Chica" },
        { id: 6, tipo: "Regalia" },
        { id: 7, tipo: "Orden abierta" }
    ]

    const isFormFieldValid = () => {

    }

    const habilitarComponentes = () => {
        setHabilitar(true)
    }

    const nuevaRequisa = () => {
        setNewRequisaDialog(true);
    };

    const enviarCorreo = async () => {
        if (values.IdPurchaseRequest > 0) {
            setLoadingCorreo(true);
            //TODO FUNCION ENVIA CORREO REQUISA
            // EnviarCorreoRequisa(infoRequisa, toastShow, setLoadingCorreo, toast);
        } else {
            toastShow(toast, 'warn', 'Requisa no encontrada', 'Guarde la requisa antes de enviar el correo.');
        }
    }

    const verificarCampos = () => {
        let err = false;
        if (!values.Area) {
            err = true;
            toastShow(toast, 'error', 'Error', 'Debe seleccionar un departamento.');
        } else if (!values.SolicitaN) {
            err = true;
            toastShow(toast, 'error', 'Error', 'Debe seleccionar el agente al que se le solicita.');
        } else if (!values.RequestType) {
            err = true;
            toastShow(toast, 'error', 'Error', 'Debe seleccionar el tipo de requisa.');
        } else if (!values.Priority) {
            err = true;
            toastShow(toast, 'error', 'Error', 'Debe seleccionar la prioridad de la requisa.');
        } else if (!values.Comment) {
            err = true;
            toastShow(toast, 'error', 'Error', 'Debe ingresar un comentario a la requisa.');
        }
        return !err;
    }
    const closeDialogRequisa = () => {
        setNewRequisaDialog(false);
        setHabilitar(false);
        resetForm();
    }

    const validarGuardado = () => {
        if (verificarCampos()) {
            guardarRequisa();
        } else {
            setNewRequisaDialog(false);
        }
    }

    const nuevaRequisaDialogFooter = (
        <React.Fragment>
            <Button className='p-button-outlined' label="No" icon="pi pi-times" onClick={closeDialogRequisa} />
            <Button className='' label="Si" type='submit' icon="pi pi-check" onClick={e => {
                if (validarGuardado()) {
                    guardarEncabezado();
                }
            }} />
        </React.Fragment>
    );



    return (
        <div className="form-demo px-3 mb-2 mt-2">
            <Dialog visible={newRequisaDialog} header="IPS" modal footer={nuevaRequisaDialogFooter} className="modal__contenedor" onHide={e => setNewRequisaDialog(false)}>
                <strong>¿Desea guadar los cambios de la requisa?</strong>
            </Dialog>
            <div className="flex justify-content-center" style={{ padding: "20 0" }} >

                <Card
                    contenido={<div >
                        <div className='d-flex gap-3'>
                            <span className='p-inputgroup' style={{ maxWidth: 235 }}>
                                <span className=" field p-float-label" >
                                    <InputText id="PurchaseRequest" name="PurchaseRequest" value={values?.PurchaseRequest} onChange={handleInputChange} autoFocus style={{ fontSize: 'x-large' }}
                                        className={classNames("p-inputtext-sm block", { 'p-invalid': isFormFieldValid('idEncabezado') })} onKeyDown={e => e.keyCode === 13 ? getRequisa(e) : null} />
                                    <label htmlFor="idEncabezado" className={classNames({ 'p-error': isFormFieldValid('idEncabezado') })}>No. Requisicion</label>
                                </span>
                                <Button icon="pi pi-search" type="button" className="p-button-info " onClick={getRequisa}
                                    tooltip="Buscar Requisa" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} />
                            </span>
                            <span className=" p-float-label Date encabezado__contenido">
                                <Calendar id="Date" name="Date" disabled value={values?.Date} dateFormat="dd/mm/yy" mask="99/99/9999"
                                    showIcon />
                                <label htmlFor="Date">Fecha</label>
                            </span>
                            <span className=" p-float-label estado encabezado__contenido ">
                                <InputText id="estado" disabled name="estado" value={values?.StatusName}
                                    className={classNames({ 'p-inputtext-sm block': isFormFieldValid('estado') })} style={{ width: '100%', padding: '6px 3px' }} />
                                <label htmlFor="estado" className={classNames({ 'p-error': isFormFieldValid('estado') })}>Estado</label>
                            </span>
                            <span className=" p-float-label usuarioIPS encabezado__contenido encabezado__contenido-inputs">
                                <InputText disabled={!habilitar} id="UserCreate" name="UserCreate" readOnly value={values?.UserCreate} autoFocus
                                    className={classNames("p-inputtext-sm block", { 'p-invalid': isFormFieldValid('usuarioIPS') })} style={{ width: '100%', padding: '6px 3px' }} />
                                <label htmlFor="usuarioIPS" className={classNames({ 'p-error': isFormFieldValid('usuarioIPS') })}>Usuario IPS</label>
                            </span>

                            <AutoCompleteDropdown
                                enable={habilitar}
                                value={values?.Priority}
                                items={prioridades}
                                field={'prioridad'}
                                name={'Priority'}
                                handleInputChange={handleInputChange}
                                tabIndex={1}
                                label={'Prioridad'}
                            />

                            <AutoCompleteDropdown
                                enable={habilitar}
                                value={values?.RequestType}
                                items={tipos}
                                field={'tipo'}
                                name={'RequestType'}
                                handleInputChange={handleInputChange}
                                tabIndex={2}
                                label={'Tipo'}
                            />

                            <AutoCompleteDropdown
                                enable={habilitar}
                                value={values.Area}
                                items={areas}
                                field={'Area'}
                                name={'Area'}
                                handleInputChange={handleInputChange}
                                tabIndex={3}
                                label={'Departamento'}
                            />
                            <AutoCompleteDropdown
                                enable={habilitar}
                                value={values.SolicitaN}
                                items={agentes}
                                field={'AgentName'}
                                name={'SolicitaN'}
                                handleInputChange={handleInputChange}
                                tabIndex={4}
                                label={'Solicita'}
                            />

                            <AutoCompleteDropdown
                                enable={habilitar && (userAuth.idUser === 213 || userAuth.IdRol === 1 )}
                                value={values.AssignedTo === 1673 ? 'Edan Orlando Velasquez Aplicano' : values?.AssignedTo}
                                items={agentesCompras}
                                field={'AgentName'}
                                name={'AssignedTo'}
                                handleInputChange={handleInputChange}
                                tabIndex={5}
                                label={'Asignado a'}
                            />
                        </div>
                        <div className='d-flex gap-3'>
                            <Card
                                titulo={"Herramientas"}
                                className='Herramientas'
                                contenido={
                                    <div className='groupEncabezado encabezado__contenido-Card d-flex gap-1' >
                                        <Button icon="pi pi-plus" disabled={!habilitar} type="button" className="p-button-info encabezado__herramienta-botones"
                                            tooltip="Agregar Items" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} onClick={e => { if (verificarCampos()) { agregarNuevaFila() } }} tabIndex={7} />
                                        <Button icon="pi pi-save" disabled={!habilitar} className="p-button-primary encabezado__herramienta-botones"
                                            tooltip="Guadar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} onClick={e => { if (verificarCampos()) { guardarEncabezado() } }} />
                                        <Button icon="pi pi-pencil" type="button" className="p-button-secondary  encabezado__herramienta-botones" onClick={habilitarComponentes}
                                            tooltip="Editar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} />
                                        <Button icon="pi pi-times" type="button" className="p-button-danger encabezado__herramienta-botones" onClick={() => eliminarItemDetalle()}
                                            tooltip="Cancelar" disabled={!habilitar} tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} />
                                        <Button icon="pi pi-book" type="button" className="p-button-info  encabezado__herramienta-botones" onClick={nuevaRequisa}
                                            tooltip="Nuevo" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} />
                                        <Button icon="pi pi-print" type="button" className="p-button-secondary listado__botones" onClick={event => window.open(`${process.env.REACT_APP_ENV}/PurchaseRequest/print/${values.PurchaseRequest}`, values.PurchaseRequest, 'height=1200,width=1000')}
                                            tooltip="Imprimir" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 2 }} />
                                        <Button icon="pi pi-envelope" type="button" className="p-button-info encabezado__herramienta-botones" loading={loadingCorreo}
                                            tooltip="Enviar Correo" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} onClick={e => enviarCorreo()} />
                                        <Button icon="pi pi-file-excel" type="button" className="p-button-success encabezado__herramienta-botones" onClick={() => exportarExcel(table, values?.PurchaseRequest)}
                                            tooltip="Export Archivo" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} />
                                        <Button icon="pi pi-sync" type="button" className="p-button-info encabezado__herramienta-botones" onClick={() => getRequisa()}
                                            tooltip="Cargar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} />
                                        {<ArchivosRequisicion idPurchase={values.IdPurchaseRequest} selected={false} />}
                                    </div>
                                } />

                            <Card className='Herramientas2'
                                contenido={
                                    <div className='d-flex encabezado__contenido-Card '>
                                        <span className="p-inputgroup encabezado__span-idEncabezado" style={{ marginLeft: 2 }}>
                                            <span className="p-float-label encabezado__boton-archivo" style={{ verticalAlign: 'center' }}>
                                                <span className='mx-2'>Calculo ISV: </span>
                                                <Checkbox id="ISV" disabled={!habilitar} name="ISV" checked={values.ISV} onChange={handleInputChange} label='ISV' />
                                            </span>
                                        </span>
                                    </div>
                                }
                            />

                            <span className=" p-float-label d-flex mt-2" style={{ alignItems: 'flex-end' }}>
                                <InputTextarea tabIndex={6} disabled={!habilitar} id="Comment" autoResize={true} name="Comment" value={values?.Comment} onChange={handleInputChange} rows={3} cols={100} placeholder
                                    className={classNames(" block", "encabezado__contenido", { 'p-invalid': isFormFieldValid('Comment') })} style={{ width: '100%', maxHeight: '4.5rem', maxWidth: '80vh', height: '4rem' }} />
                                <label id="label_comentario" htmlFor="Comment" className={classNames('encabezado__contenido', { 'p-error': isFormFieldValid('Comment') })}>Comentarios</label>
                            </span>
                            <span className=" p-float-label usuarioIPS encabezado__contenido encabezado__contenido-inputs">
                            </span>
                            <span className='position-relative Comment  d-flex' >
                            </span>
                        </div>
                    </div>}
                />
            </div>
        </div>
    )
}

export default EncabezadoRequisicion